import type { TOption } from "../components/Autocomplete/Autocomplete";
import { packageNameWithSource, productDisplayNameWithSource } from "../utils";

export type EodCurveProduct = {
  id: string;
  name: string;
  description?: string | null;
  package?: string | number | null;
  packageByPackage?: {
    name?: string | null;
    sourceBySource?: {
      name?: string | null;
      source_type?: string | null;
      exchange?: { code?: number | null } | null;
    } | null;
  } | null;
};

const NONE_OPTION: TOption = {
  label: "None",
  value: "",
  groupValue: "",
  shortName: "None",
  sortSourceType: "ungrouped",
};

function productSourceSort(product: EodCurveProduct) {
  let sourceType = product.packageByPackage?.sourceBySource?.source_type;
  const sourceName = product.packageByPackage?.sourceBySource?.name ?? "";
  if (!sourceType) {
    const exchange = product.packageByPackage?.sourceBySource?.exchange;
    if (exchange !== null && exchange !== undefined) {
      sourceType = "exchange";
    } else if (sourceName.toLowerCase().includes("artis")) {
      sourceType = "organisation";
    } else {
      sourceType = "eod";
    }
  }
  return { sourceType, sourceName };
}

export function makeEodCurveOptions(products: readonly EodCurveProduct[]): TOption[] {
  const curveOptions = products
    .map((product) => {
      const packageName = product.packageByPackage?.name || "";
      const packageWithSource = packageNameWithSource({ packageByPackage: product.packageByPackage });
      const { sourceType, sourceName } = productSourceSort(product);

      return {
        label: productDisplayNameWithSource(product),
        value: product.id,
        groupValue: packageWithSource || packageName,
        groupLabel: packageWithSource,
        groupKey: String(product.package ?? packageName ?? product.id),
        shortName: product.name,
        longName: product.description && product.description !== product.name ? product.description : undefined,
        sortSourceType: sourceType,
        sortSourceName: sourceName,
        sortPackageName: packageName,
      };
    })
    .sort((a, b) => a.shortName.localeCompare(b.shortName, undefined, { sensitivity: "base" }));

  return [NONE_OPTION, ...curveOptions];
}
